import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useFormik } from "formik";
import { globalLoader, handleServerValidations } from "../../../../utils/commonfunction";
import { forgetPassword } from "../../services/auth.services";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import logo from "../../../../assets/Discount_App_logo.png";
import loginImage from "../../../../assets/business/images/login-page-img.png";
import CustomError from "../../../../utils/customError";
import * as Yup from "yup";

const BusinessForgotPwdPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .required(t("Email is required"))
      .test("is-valid-email", t("Enter a valid email"), function (value) {
        if (!value) return false;

        const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const phoneRegex = /^\+?[0-9]{1,4}[\s]?[0-9]{6,14}$/;

        return emailRegex.test(value) || phoneRegex.test(value);
      }),
  });

  const formik = useFormik({
    initialValues: { email: "" },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      globalLoader(true);

      const input = values.email.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^\+(\d{1,4})\s(\d{6,15})$/;

      const isEmail = emailRegex.test(input);
      const isPhone = phoneRegex.test(input);

      const formData = new FormData();

      if (isEmail) {
        formData.append("email", input.toLowerCase());
      } else if (isPhone) {
        const match = input.match(phoneRegex);
        const countryCode = `+${match[1]}`;
        const phone = match[2];
        const fullNumber = `${countryCode} ${phone}`;
        const phone_number = {
          countryCode,
          phone,
          fullNumber,
        };
        formData.append("phone_number", JSON.stringify(phone_number));
      } else {
        globalLoader(false);
        Swal.fire({
          icon: "error",
          text: "Please enter a valid email",
          ...SWAL_SETTINGS,
        });
        return;
      }

      forgetPassword(formData)
        .then((response) => {
          globalLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            navigate("/business/otp-verification", {
              state: {
                email: values.email,
                type_data: isEmail ? "email" : "",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          globalLoader(false);
          console.log("error--->", error);
        });
    },
  });

  return (
    <section className="welcome-screen">
      <div className="row m-0 align-items-center vh-100">
        <div className="col-md-6 p-0">
          <div className="welcome-screen-box login-box">
            <div className="welcome-screen-box-in py-4">
              <div className="back-button">
                <Link to="/business/login" className="d-flex align-items-center gap-2">
                  <i className="fi-rr-arrow-small-left"></i> <span>Back</span>
                </Link>
              </div>
              <div className="logo text-center mb-4">
                <a href="javascript#">
                  <img src={logo} alt="logo-img" />
                </a>
              </div>
              <div className="heading-text-auth mb-3">
                <h3 className="h3-headline text-center">Forget your password</h3>
                <p className="subtitle-1 text-center mt-4"> Enter your registered email</p>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  formik.handleSubmit();
                }}
                className="text-start gap-3 w-100">
                <div className="text-start gap-3 mt-3">
                  <div className="input">
                    <label className="form-label subtitle-1" htmlFor="email">
                      Email<span className="requirestar">*</span>
                    </label>
                    <input id={"email"} type="text" className="form-control" name="email" placeholder={t("Enter Email")} value={formik?.values?.email} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={formik} />
                    </span>
                  </div>
                </div>
                <div className="get-started-btn mt-4 d-flex flex-column gap-3">
                  <button className="btn btn-oring w-50 mx-auto" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-md-6 p-0">
          <div className="hero-img">
            <img src={loginImage} className="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessForgotPwdPage;
